import type { ModalBaseProps } from "@/stores/application/types";
import { Button, Modal } from "antd";
import { WarningCircle, Xmark } from "iconoir-react";
import Icons from "../Icons";

export interface ConfirmModalProps extends ModalBaseProps {
  title: React.ReactNode;
  description?: React.ReactNode;
  confirmLabel?: string | null;
  cancelLabel?: string;
  onCancel?: () => void;
  isError?: boolean;
  hiddenCancel?: boolean;
  hiddenClose?: boolean;
}

const ConfirmModal = ({
  onClose,
  title,
  confirmLabel = "Xác nhận",
  cancelLabel = "Thoát",
  onSubmit,
  onCancel,
  loading,
  description,
  isError,
  hiddenCancel,
  hiddenClose,
}: ConfirmModalProps) => {
  return (
    <Modal
      maskClosable={false}
      closable={false}
      className="!w-fit min-w-96 max-w-[600px]"
      centered
      open
      footer={
        <div className="flex justify-end gap-3">
          {!hiddenCancel && (
            <Button
              onClick={() => {
                if (onCancel) {
                  onCancel();
                  onClose?.();
                } else {
                  onClose?.();
                }
              }}
            >
              {cancelLabel}
            </Button>
          )}
          {confirmLabel && (
            <Button loading={loading} onClick={onSubmit} type="primary">
              {confirmLabel}
            </Button>
          )}
        </div>
      }
    >
      <div className="pb-2 relative">
        <div className="grid grid-cols-[22px_1fr] gap-4">
          {isError ? <Icons size={22} name="close-circle" /> : <WarningCircle color="#FAAD14" width={24} height={24} />}
          <div className="flex flex-col gap-2">
            <div className="font-semibold opacity-85 text-base mr-6">{title}</div>
            <div>{description}</div>
          </div>
        </div>
        <div className="absolute -top-2 -right-2">
          {!hiddenClose && (
            <Button
              className="!outline-none !p-0 shadow-none w-[30px] h-[30px] !border-none text-black/45"
              onClick={onClose}
            >
              <Xmark width={24} height={24} />
            </Button>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmModal;
